module.exports = __webpack_public_path__ + "static/media/airenlei2.4d37483a.png";